"use client";
/**
 * Home page.
 *
 * Authenticated users are redirected to /workshops.
 * Unauthenticated users see login / register links.
 */

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import Link from "next/link";
import { useAuth } from "@/lib/auth";
import { Button, Spinner } from "@/components/ui";

export default function Home() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!loading && user) router.replace("/workshops");
  }, [loading, user, router]);

  if (loading) {
    return (
      <main className="space-y-6 pt-8">
        <Spinner label="Loading…" />
      </main>
    );
  }

  // Not loading and no user — show landing
  return (
    <main className="space-y-8">
      <header className="space-y-2">
        <h1 className="text-3xl font-bold tracking-tight text-blue-700">
          Workshop Memory
        </h1>
        <p className="text-gray-500 text-sm">
          Visual memory system for workshop locations.
        </p>
      </header>

      <div className="flex flex-col gap-3 max-w-xs">
        <Link href="/login">
          <Button className="w-full">Sign in</Button>
        </Link>
        <Link href="/register">
          <Button variant="secondary" className="w-full">
            Create account
          </Button>
        </Link>
      </div>
    </main>
  );
}
